import angular from 'angular';
import Configs from '../../../configs/configs';

export class LogoutController {
  /* @ngInject */
  constructor($auth, $state, $http, api, $cacheFactory, $window) {
    $cacheFactory.get('$http').removeAll();

    if ($auth.isAuthenticated()) {
      $http.post(`${api.baseURL}/oauth/token/revoke`, {
        access_token: $auth.getToken(),
        token_type: 'bearer'
      }, {
        headers: { 'Requested-From-Component': 'pepapi-frontend'},
      }).then(() => {
        $auth.logout();
        $state.go('login');
        const url = $window.location.href.endsWith(`#/logout`) ? $window.location.href.replace(`#/logout`, ``) : $window.location.href;
        $window.location.replace(url);
      });
    }
  }
}

export function LogoutComponent() {
  return {
    template: '',
    controller: LogoutController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('logout', [
  Configs.name,
  'toastr'
])
.config(($stateProvider) => {
  $stateProvider
    .state('logout', {
      url: '/logout',
      template: '<logout></logout>'
    });
})
.directive('logout', LogoutComponent);



/** WEBPACK FOOTER **
 ** ./src/components/account/logout/logout.js
 **/